/**
 * Gets tile from tile position (logic-wise). Wraps overflowing positions
 * @template T
 * @param {Position} position Coords to fetch
 * @param {T[]} data flat item array
 * @param {number} gridSize amount of items per row
 * @returns {T} tile at grid
 */
export function fetchByCoords(position, data, gridSize) {
  const x = position.x < 0 ? position.x + gridSize : position.x % gridSize;
  const y = position.y < 0 ? position.y + gridSize : position.y % gridSize;
  return data[y * gridSize + x];
}

/**
 *
 * @param {Selection} selection
 * @param {Tile[]} soupData
 * @param {number} gridSize
 * @returns {string}
 */
export function getWordFromSelection(selection, soupData, gridSize) {
  if (selection.origin === selection.destination) return null;

  let actual = selection.origin;
  let word = "";
  let steps = 0;
  const MAX_STEPS = gridSize * 2; 

  while (actual !== selection.destination && steps < MAX_STEPS) {
    if (!actual?.letter) return null;
    word += actual.letter;

    const nextPosition = {
      x: actual.position.x + selection.direction.x,
      y: actual.position.y + selection.direction.y,
    };

    if (nextPosition.x < 0 || nextPosition.x >= gridSize ||
      nextPosition.y < 0 || nextPosition.y >= gridSize) {
      return word.length > 0 ? word : null;
    }

    actual = fetchByCoords(nextPosition, soupData, gridSize);
    steps++;
  }

  if (steps >= MAX_STEPS) {
    return null;
  }

  if (actual && actual.letter) {
    word += actual.letter;
  }

  return word;
}
